import { render, staticRenderFns } from "./gallerylogin.vue?vue&type=template&id=7bcc6e8d&scoped=true&"
import script from "./gallerylogin.vue?vue&type=script&lang=js&"
export * from "./gallerylogin.vue?vue&type=script&lang=js&"
import style0 from "./gallerylogin.vue?vue&type=style&index=0&id=7bcc6e8d&prod&lang=css&"
import style1 from "./gallerylogin.vue?vue&type=style&index=1&id=7bcc6e8d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcc6e8d",
  null
  
)

export default component.exports